import { render } from "./ReasonsDisplay.vue?vue&type=template&id=238e340c&scoped=true"
import script from "./ReasonsDisplay.vue?vue&type=script&lang=js"
export * from "./ReasonsDisplay.vue?vue&type=script&lang=js"

import "./ReasonsDisplay.vue?vue&type=style&index=0&id=238e340c&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238e340c"]])

export default __exports__